import {ChildrenProps, ClassNameProps} from '@app/helpers/react';
import {Children, forwardRef} from 'react';
import styled, {css} from 'styled-components';

import {colorVar} from './Theme/colors';

interface Props extends ChildrenProps, ClassNameProps, ContainerProps {}

interface ContainerProps extends ClassNameProps {
  fill?: boolean;
  scrollable?: boolean;
  divide?: boolean;
}

export const InputGroupContainer = styled.div<ContainerProps>`
  contain: layout;
  display: flex;
  ${({scrollable}) => scrollable && 'overflow-x: auto;'}
  ${({fill}) =>
    fill &&
    css`
      flex-grow: 1;
    `}
  ${({divide}) =>
    divide &&
    css`
      > *:not(:last-child) {
        > * {
          border-right: 1px solid ${colorVar('secondaryContainer')};
        }
      }
    `}
  
  > * > * {
    position: relative;
  }

  [data-selected] {
    position: relative;
    z-index: 2;
  }

  > * > *:hover {
    position: relative;
    z-index: 1;
  }
`;

const InputGroup = forwardRef<HTMLDivElement, Props>(
  ({children, fill, scrollable, divide, ...props}, ref) => (
    <InputGroupContainer
      ref={ref}
      fill={fill}
      scrollable={scrollable}
      divide={divide}
      {...props}
    >
      {Children.map(
        children,
        (child, i) =>
          child && (
            <div style={{display: 'contents'}} key={i}>
              {child}
            </div>
          )
      )}
    </InputGroupContainer>
  )
);

export default InputGroup;
